//Константы из SetupView
export default {
  list: {
    loading: "Loading asset list..."
  },
  loading: "Loading list...",
  create: "Create:",
  clear: "Clear",
  confirm: {
    first: "Warning!\nAll configured views for this asset will be removed!",
    second: "ATTENTION!\nALL configured views for this asset will be removed!"
  },
  tabs: {
    table: "Lists and Tables",
    tree: "Trees",
    env: "Environment",
    graph: "Graphs",
    html: "Other views",
    cmp: "Comparisons",
    exporter: "Exporter",
    all: "All views"
  }

}
